const SEEN_PREFIX = 'innex-home-seen:';
const SESSION_PREFIX = 'innex-home-first-view:';
const NEW_ACCOUNT_MS = 24 * 60 * 60 * 1000;
const SAME_SIGN_IN_MS = 2 * 60 * 1000;

type Store = Pick<Storage, 'getItem' | 'setItem'>;

// The first time someone opens the app, greet them as new. Later visits say
// "Welcome back". A refresh of that first visit stays a first visit for the
// browser tab. Accounts older than a day are treated as returning so existing
// users are not greeted as new the first time this check runs.
export function isFirstAppView({
  userId,
  navigationFirstView,
  creationTime,
  lastSignInTime,
  now = Date.now(),
  localStore,
  sessionStore
}: {
  userId: string | null;
  navigationFirstView: boolean;
  creationTime?: string;
  lastSignInTime?: string;
  now?: number;
  localStore?: Store;
  sessionStore?: Store;
}): boolean {
  if (!userId) return navigationFirstView;

  const sessionKey = SESSION_PREFIX + userId;
  const seenKey = SEEN_PREFIX + userId;

  try {
    const local = localStore ?? localStorage;
    const session = sessionStore ?? sessionStorage;

    if (session.getItem(sessionKey) === '1') return true;

    const seen = local.getItem(seenKey) === '1';
    const created = creationTime ? Date.parse(creationTime) : Number.NaN;
    const signedIn = lastSignInTime ? Date.parse(lastSignInTime) : Number.NaN;
    const accountIsNew = Number.isFinite(created) && now - created >= 0 && now - created < NEW_ACCOUNT_MS;
    const firstSignIn = accountIsNew && Number.isFinite(signedIn) && Math.abs(signedIn - created) < SAME_SIGN_IN_MS;
    const firstView = navigationFirstView || (!seen && firstSignIn);

    if (firstView) {
      session.setItem(sessionKey, '1');
      local.setItem(seenKey, '1');
      return true;
    }

    local.setItem(seenKey, '1');
    return false;
  } catch {
    return navigationFirstView;
  }
}
